module.exports = __webpack_public_path__ + "static/media/football-carousel-2-360x640.efcf3c81.jpg";